import {
  INBOX_NOTIFICATION_TYPE,
  NOTIFICATION_RING_MS,
  type InboxNotification,
} from '../constants/notifications'

const seenIds = new Set<string>()
let primed = false
let sessionUserId: string | null = null
let ringing = false
let ringTimer = 0
const ringListeners = new Set<(value: boolean) => void>()

export function bindNotificationSession(userId: string) {
  if (sessionUserId === userId) return
  sessionUserId = userId
  seenIds.clear()
  primed = false
}

export function isNotificationSessionPrimed(): boolean {
  return primed
}

export function absorbNotifications(
  items: InboxNotification[],
  live: boolean,
): InboxNotification[] {
  if (!primed && !live) {
    for (const item of items) seenIds.add(item.id)
    primed = true
    return []
  }
  const fresh = items.filter((item) => !seenIds.has(item.id))
  for (const item of fresh) seenIds.add(item.id)
  return fresh
}

export function subscribeNotificationRing(listener: (value: boolean) => void): () => void {
  ringListeners.add(listener)
  listener(ringing)
  return () => {
    ringListeners.delete(listener)
  }
}

function setRinging(next: boolean) {
  ringing = next
  for (const listener of ringListeners) listener(next)
}

let audioContext: AudioContext | null = null

export function unlockNotificationSound() {
  const Ctx = window.AudioContext
  if (!Ctx) return
  if (!audioContext) audioContext = new Ctx()
  if (audioContext.state === 'suspended') void audioContext.resume()
}

function ding(ctx: AudioContext, when: number, frequency: number, duration: number) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = 'sine'
  osc.frequency.setValueAtTime(frequency, when)
  gain.gain.setValueAtTime(0.0001, when)
  gain.gain.exponentialRampToValueAtTime(0.2, when + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, when + duration)
  osc.connect(gain)
  gain.connect(ctx.destination)
  osc.start(when)
  osc.stop(when + duration + 0.02)
}

export function playOrderBell() {
  unlockNotificationSound()
  if (!audioContext) return
  const start = audioContext.currentTime
  ding(audioContext, start, 880, 0.22)
  ding(audioContext, start + 0.16, 1175, 0.32)
}

export function alertForNotifications(items: InboxNotification[]) {
  const hasOrder = items.some(
    (item) => item.type === INBOX_NOTIFICATION_TYPE.orderAssigned,
  )
  if (!hasOrder) return
  playOrderBell()
  setRinging(true)
  window.clearTimeout(ringTimer)
  ringTimer = window.setTimeout(() => setRinging(false), NOTIFICATION_RING_MS)
}
